import { render, staticRenderFns } from "./paymentBreakdown.vue?vue&type=template&id=627c38fb&scoped=true"
import script from "./paymentBreakdown.vue?vue&type=script&lang=js"
export * from "./paymentBreakdown.vue?vue&type=script&lang=js"
import style0 from "./paymentBreakdown.vue?vue&type=style&index=0&id=627c38fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c38fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627c38fb')) {
      api.createRecord('627c38fb', component.options)
    } else {
      api.reload('627c38fb', component.options)
    }
    module.hot.accept("./paymentBreakdown.vue?vue&type=template&id=627c38fb&scoped=true", function () {
      api.rerender('627c38fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/paymentBreakdown.vue"
export default component.exports